/* KAIROS KOLYE FINAL V1 — 2026-09-17
 * Isolated, single-source variant state for the kolye section.
 * No global product-selector patch, no DOM movement, no second cart API call.
 * The sticky submits the existing main ProductForm (quantity/properties included).
 * Shopify-rendered money and Section Rendering keep market prices consistent.
 */
(() => {
  'use strict';
  if (window.KairosNecklaceFinalV1) { window.KairosNecklaceFinalV1.boot(); return; }
  const ROOT = '[data-kairos-necklace-final]';
  const instances = new WeakMap();
  const same = (a, b) => String(a ?? '') === String(b ?? '');

  function init(root) {
    if (instances.has(root)) return;
    const purchase = root.querySelector('product-form[data-kairos-purchase]');
    const mainForm = purchase?.querySelector('form');
    const mainButton = mainForm?.querySelector('button[name="add"].no-js-hidden');
    const native = root.querySelector('[data-knf-native-variant]');
    const bar = root.querySelector('[data-knf-sticky]');
    const stickyForm = bar?.querySelector('[data-knf-sticky-form]');
    const stickyButton = bar?.querySelector('[data-knf-sticky-submit]');
    const config = root.querySelector('[data-knf-variants]');
    if (!mainForm || !mainButton || !native || !bar || !config) return;
    let variants, money;
    try {
      variants = JSON.parse(config.textContent);
      money = JSON.parse(root.querySelector('[data-knf-money]').textContent);
      if (!Array.isArray(variants) || !variants.length) return;
    } catch (error) { console.warn('[Kairos Kolye] Varyant verisi okunamadı.', error); return; }
    const getById = id => variants.find(v => same(v.id, id));
    const getByOptions = values => variants.find(v => v.options.length === values.length && v.options.every((value, i) => same(value, values[i])));
    const initial = getById(native.value) || variants.find(v => v.available) || variants[0];
    let current = initial;
    let chosen = initial.options.slice();
    let request = null;
    let serial = 0;
    let dead = false;
    let frame = 0;
    const teardown = [];
    const optionsUI = root.querySelector('[data-knf-options]');
    const priceRegion = root.querySelector('[id^="Product-Price-"]');
    const status = root.querySelector('[data-knf-status]');
    const stickyError = bar.querySelector('[data-knf-sticky-error]');
    const baseImage = bar.querySelector('img')?.getAttribute('src') || '';
    const mainMedia = root.querySelector('product-media');
    const mainError = purchase.querySelector('[data-error-wrapper]');
    const stickyId = bar.querySelector('[data-knf-sticky-id]');
    const on = (node, event, handler, opts) => {
      if (!node) return;
      node.addEventListener(event, handler, opts);
      teardown.push(() => node.removeEventListener(event, handler, opts));
    };
    const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
    const unavailableText = v => v ? 'Tükendi' : 'Bu seçenek kombinasyonu mevcut değil.';
    const busy = () => mainButton.classList.contains('disabled') || mainButton.getAttribute('aria-busy') === 'true';
    const formatted = (variant, field) => money[String(variant.id)]?.[field] ?? '';

    function updateButtons() {
      const working = busy();
      const disabled = working || !current?.available;
      mainButton.disabled = disabled;
      if (!working) setText(mainButton, current?.available ? (window.variantStrings?.addToCart || 'Sepete Ekle') : unavailableText(current));
      if (stickyButton) {
        stickyButton.disabled = disabled;
        stickyButton.setAttribute('aria-busy', working ? 'true' : 'false');
        setText(stickyButton, working ? 'Ekleniyor…' : current?.available ? 'Sepete Ekle' : 'Tükendi');
      }
      if (optionsUI) optionsUI.querySelectorAll('button, select').forEach(control => { control.disabled = working; });
      bar.querySelectorAll('[data-knf-sticky-option]').forEach(control => { control.disabled = working; });
      if (stickyError) {
        const message = mainError && !mainError.classList.contains('hidden') ? mainError.textContent : '';
        setText(stickyError, message || '');
        stickyError.hidden = !message;
      }
    }
    function updatePrice(variant) {
      if (!priceRegion) return;
      if (!variant) { priceRegion.hidden = true; return; }
      priceRegion.hidden = false;
      const container = priceRegion.querySelector('.price__container');
      if (!container) return;
      container.querySelectorAll(':scope > .price__regular, :scope > .price__sale').forEach(el => el.remove());
      const sale = Number(variant.compare_at_price) > Number(variant.price);
      const price = priceRegion.querySelector('.price');
      price?.classList.toggle('price--on-sale', sale);
      price?.classList.toggle('price--sold-out', !variant.available);
      const wrapper = document.createElement('div');
      wrapper.className = sale ? 'price__sale' : 'price__regular';
      const inner = sale ? document.createElement('div') : wrapper;
      if (sale) { inner.className = 'price__sale-inner'; wrapper.append(inner); }
      const sr = document.createElement('span');
      sr.className = 'visually-hidden'; sr.textContent = 'Güncel fiyat'; inner.append(sr);
      const amount = document.createElement(sale ? 'ins' : 'span');
      amount.textContent = formatted(variant, 'price'); inner.append(amount);
      if (sale) {
        const oldLabel = document.createElement('span');
        oldLabel.className = 'visually-hidden'; oldLabel.textContent = 'Önceki fiyat'; inner.append(oldLabel);
        const old = document.createElement('del'); old.textContent = formatted(variant, 'compare'); inner.append(old);
      }
      container.prepend(wrapper);
      setText(bar.querySelector('[data-knf-sticky-price]'), formatted(variant, 'price'));
    }
    function updateOptions() {
      root.querySelectorAll('[data-knf-option-group]').forEach(group => {
        const i = Number(group.dataset.optionIndex);
        group.querySelectorAll('button[data-knf-value]').forEach(button => {
          const selected = same(chosen[i], button.dataset.knfValue);
          button.setAttribute('aria-pressed', String(selected));
          if (selected) setText(group.querySelector('[data-knf-current]'), '14K ' + button.dataset.knfLabel);
          const proposal = chosen.slice(); proposal[i] = button.dataset.knfValue;
          const match = getByOptions(proposal);
          button.classList.toggle('is-unavailable', !match?.available);
          const note = button.querySelector('[data-knf-stock]');
          if (note) { note.hidden = !!match?.available; setText(note, !match ? 'Bu kombinasyon yok' : !match.available ? 'Tükendi' : ''); }
          button.setAttribute('aria-label', button.dataset.knfLabel + (!match ? ' — Bu kombinasyon yok' : !match.available ? ' — Tükendi' : ''));
        });
        group.querySelectorAll('select[data-knf-option]').forEach(select => { select.value = chosen[i]; });
      });
      bar.querySelectorAll('select[data-knf-sticky-option]').forEach(select => { select.value = chosen[Number(select.dataset.knfStickyOption)]; });
      if (status) { status.hidden = !!current?.available; setText(status, current?.available ? '' : unavailableText(current)); }
    }
    function updateMedia(variant) {
      if (!variant) return;
      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (mediaId && mainMedia?.settings?.sliderInstance && typeof mainMedia.setActiveMedia === 'function') {
        mainMedia.setActiveMedia(Number(mediaId));
      }
      const image = bar.querySelector('img');
      let src = variant.featured_image?.src || variant.featured_image?.url || variant.featured_media?.preview_image?.src || baseImage;
      if (image && src) {
        if (src.startsWith('//')) src = 'https:' + src;
        image.removeAttribute('srcset');
        if (image.getAttribute('src') !== src) image.src = src;
      }
    }
    function updateURL(variant) {
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
      url.searchParams.delete('option_values');
      window.history.replaceState(window.history.state, '', url);
    }
    async function refreshInfo(variant) {
      const generation = ++serial;
      request?.abort();
      if (!variant) { priceRegion?.removeAttribute('aria-busy'); return; }
      request = new AbortController();
      const url = new URL(root.dataset.productUrl, window.location.origin);
      new URL(window.location.href).searchParams.forEach((value, key) => {
        if (!['section_id', 'sections', 'option_values'].includes(key)) url.searchParams.set(key, value);
      });
      url.searchParams.set('variant', variant.id);
      url.searchParams.set('section_id', root.dataset.section);
      priceRegion?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(String(response.status));
        const text = await response.text();
        if (dead || generation !== serial || !same(current?.id, variant.id)) return;
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const remote = doc.querySelector(ROOT);
        if (!remote) return;
        ['Product-Price-', 'Product-Purchase-Options-'].forEach(prefix => {
          const target = root.querySelector('[id="' + prefix + root.dataset.section + '"]');
          const source = doc.getElementById(prefix + root.dataset.section);
          if (target && source) target.innerHTML = source.innerHTML;
        });
        const inventory = root.querySelector('[data-inventory-notice]');
        const replacement = remote.querySelector('[data-inventory-notice]');
        if (inventory && replacement) inventory.innerHTML = replacement.innerHTML;
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('[Kairos Kolye] Ek ürün bilgisi yenilenemedi; seçili varyant fiyatı korunuyor.', error);
      } finally {
        if (generation === serial) priceRegion?.removeAttribute('aria-busy');
      }
    }
    function commit(variant, { url = true, fetchInfo = true, media = true } = {}) {
      current = variant || null;
      if (variant) chosen = variant.options.slice();
      native.value = variant ? String(variant.id) : '';
      if (stickyId) stickyId.value = native.value;
      const installments = root.querySelector('form.installment input[name="id"]');
      if (installments) installments.value = native.value;
      root.querySelectorAll('.variant-sku').forEach(el => setText(el, variant?.sku || ''));
      const inventory = root.querySelector('[data-inventory-notice]');
      if (inventory && fetchInfo) inventory.innerHTML = ''; // no previous colour's stock claim
      purchase.handleErrorMessage?.();
      updatePrice(current); updateOptions(); updateButtons();
      if (media) updateMedia(current);
      if (url) updateURL(current);
      if (fetchInfo) refreshInfo(current);
      const pickup = root.querySelector('pickup-availability');
      if (pickup && fetchInfo) {
        pickup.dataset.variantId = native.value;
        pickup.toggleAttribute('available', !!current?.available);
        if (current?.available && typeof pickup.fetchAvailability === 'function') pickup.fetchAvailability(native.value);
        else pickup.innerHTML = '';
      }
      root.dispatchEvent(new CustomEvent('kairos:necklace-variant-changed', { bubbles: true, detail: { variant: current } }));
    }
    function choose(index, value) {
      if (busy() || !Number.isInteger(index) || index < 0 || index >= chosen.length) return;
      chosen[index] = value;
      commit(getByOptions(chosen));
    }
    on(optionsUI, 'click', event => {
      const button = event.target.closest('button[data-knf-option]');
      if (button && optionsUI.contains(button)) choose(Number(button.dataset.knfOption), button.dataset.knfValue);
    });
    on(optionsUI, 'change', event => {
      if (event.target.matches('select[data-knf-option]')) choose(Number(event.target.dataset.knfOption), event.target.value);
    });
    on(bar, 'change', event => {
      if (event.target.matches('[data-knf-sticky-option]')) choose(Number(event.target.dataset.knfStickyOption), event.target.value);
    });
    on(native, 'change', () => commit(getById(native.value)));
    // Capture only this form. The existing ProductForm owns the cart and drawer.
    on(mainForm, 'submit', event => {
      if (!current?.available || busy()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      native.value = String(current.id);
    }, true);
    on(stickyForm, 'submit', event => {
      event.preventDefault();
      if (!current?.available || busy()) return;
      if (typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit(mainButton);
      else mainButton.click();
    });
    const buttonObserver = new MutationObserver(updateButtons);
    // Watching only the loading class avoids observing mutations we write ourselves.
    buttonObserver.observe(mainButton, { attributes: true, attributeFilter: ['class'] });
    if (mainError) buttonObserver.observe(mainError, { attributes: true, childList: true, subtree: true, characterData: true });
    teardown.push(() => buttonObserver.disconnect());

    function visibility() {
      frame = 0;
      if (dead || !root.isConnected) return;
      const dialog = document.querySelector('dialog[open], cart-drawer[open], cart-drawer.is-open, .pswp--open');
      const past = mainButton.getBoundingClientRect().bottom < 0;
      const visible = past && !dialog;
      bar.classList.toggle('is-visible', visible);
      bar.inert = !visible;
      bar.setAttribute('aria-hidden', String(!visible));
      root.style.setProperty('--knf-sticky-space', visible ? (bar.offsetHeight + 16) + 'px' : '0px');
    }
    const scheduleVisibility = () => { if (!frame && !dead) frame = requestAnimationFrame(visibility); };
    on(window, 'scroll', scheduleVisibility, { passive: true });
    on(window, 'resize', scheduleVisibility, { passive: true });
    on(window, 'pageshow', () => { commit(getById(new URL(location.href).searchParams.get('variant')) || current || initial, { url: false, fetchInfo: false }); scheduleVisibility(); });
    on(window, 'popstate', () => { commit(getById(new URL(location.href).searchParams.get('variant')) || initial, { url: false }); });
    on(document, 'cart:open', () => { bar.classList.remove('is-visible'); bar.inert = true; bar.setAttribute('aria-hidden', 'true'); });
    const resize = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(scheduleVisibility) : null;
    resize?.observe(bar); teardown.push(() => resize?.disconnect());
    optionsUI && (optionsUI.hidden = false);
    root.querySelector('[data-knf-native-wrapper]')?.setAttribute('hidden', '');
    bar.hidden = false;
    commit(initial, { url: false, fetchInfo: false });
    scheduleVisibility();
    instances.set(root, () => {
      dead = true; ++serial; request?.abort();
      if (frame) cancelAnimationFrame(frame);
      teardown.forEach(fn => fn());
      bar.hidden = true; bar.inert = true;
      if (optionsUI) optionsUI.hidden = true;
      root.querySelector('[data-knf-native-wrapper]')?.removeAttribute('hidden');
      instances.delete(root);
    });
  }
  function boot(scope = document) {
    if (scope.matches?.(ROOT)) init(scope);
    scope.querySelectorAll(ROOT).forEach(init);
  }
  window.KairosNecklaceFinalV1 = { boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.(ROOT)) instances.get(event.target)?.();
    event.target.querySelectorAll(ROOT).forEach(root => instances.get(root)?.());
  });
})();
